import { Select } from '@vitvio/design-system';
import { parsedTimezones } from './timezone-parser';

interface TimezoneSelectorProps {
  value: string;
  onChange: (newValue: string) => void;
}

export function TimezoneSelector({ value, onChange }: TimezoneSelectorProps) {
  function handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
    onChange(e.target.value);
  }

  return (
    <Select value={value} onChange={handleChange}>
      <option value="" disabled>
        None
      </option>
      {Object.entries(parsedTimezones).map(([key, value]) => (
        <option key={key} value={key}>
          {value}
        </option>
      ))}
    </Select>
  );
}
